import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: [],
};

const getListProgramSlice = createSlice({
  name: "getListProgram",
  initialState,
  reducers: {
    getListProgramStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListProgramSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListProgramFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetListProgram: (state) => {
      state.status = ReduxStateType.INIT;
      state.data = [];
    },
  },
});

export const {
  getListProgramStart,
  getListProgramSuccess,
  getListProgramFailed,
  resetListProgram,
} = getListProgramSlice.actions;

export default getListProgramSlice.reducer;
